import { createSlice } from "@reduxjs/toolkit";

const inboundProcessState = {
  POIsValid: false,
  POVerificationLoading: false,
  verifiedPO: false,
  purchaseOrder: null,
  purchaseOrders: [],
  POItems: [],
  POItemsLoading: false,
  inboundRequest: null,
  inboundRequestLoading: false,
  inboundRequests: [],
  inboundRequestsLoading: false,
  submitInboundRequestLoading: false,
  submitInboundRequestError: false,
  saveChangesLoading: false,
  documentNumber: "",
  submitCurrencyError: false,
  inboundRequestStatusChangeSubmitLoading: false,
  inboundRequestStatusChangeDraftLoading: false,
  inboundRequestStatusChangePendingLoading: false,
  inboundRequestStatusChangeApproveLoading: false,
  incotermField: "",
  incotermFieldLoading: false,
  inboundRequestsItemsQuantityOfPO: 0,
  brandTolerances: null,
  brandTolerancesLoading: false,
  pickupAutocompleteData: null,
  pickupAutocompleteDataLoading: false,
  supplierAddresses: null,
  supplierAddressesLoading: false,
  inboundRequestEmailHistory: [],
};

const reducers = {
  setPOIsValid(state, action) {
    state.POIsValid = action.payload;
  },
  setPOVerificationLoading(state, action) {
    state.POVerificationLoading = action.payload;
  },
  setVerifiedPO(state, action) {
    state.verifiedPO = action.payload;
  },
  setPurchaseOrder(state, action) {
    state.purchaseOrder = action.payload;
  },
  setPurchaseOrders(state, action) {
    state.purchaseOrders = action.payload;
  },
  setPOItems(state, action) {
    state.POItems = action.payload;
  },
  setPOItemsLoading(state, action) {
    state.POItemsLoading = action.payload;
  },
  setInboundRequest(state, action) {
    state.inboundRequest = action.payload;
  },
  setInboundRequestLoading(state, action) {
    state.inboundRequestLoading = action.payload;
  },
  setInboundRequests(state, action) {
    state.inboundRequests = action.payload;
  },
  setInboundRequestsLoading(state, action) {
    state.inboundRequestsLoading = action.payload;
  },
  setSubmitInboundRequestLoading(state, action) {
    state.submitInboundRequestLoading = action.payload;
  },
  setDocumentNumber(state, action) {
    state.documentNumber = action.payload;
  },
  setSubmitInboundRequestError(state, action) {
    state.submitInboundRequestError = action.payload;
  },
  setSaveChangesLoading(state, action) {
    state.saveChangesLoading = action.payload;
  },
  setSubmitCurrencyError(state, action) {
    state.submitCurrencyError = action.payload;
  },
  setInboundRequestStatusChangeSubmitLoading(state, action) {
    state.inboundRequestStatusChangeSubmitLoading = action.payload;
  },
  setInboundRequestStatusChangeDraftLoading(state, action) {
    state.inboundRequestStatusChangeDraftLoading = action.payload;
  },
  setInboundRequestStatusChangePendingLoading(state, action) {
    state.inboundRequestStatusChangePendingLoading = action.payload;
  },
  setInboundRequestStatusChangeApproveLoading(state, action) {
    state.inboundRequestStatusChangeApproveLoading = action.payload;
  },
  setIncotermField(state, action) {
    state.incotermField = action.payload;
  },
  setIncotermFieldLoading(state, action) {
    state.incotermFieldLoading = action.payload;
  },
  setInboundRequestsItemsQuantityOfPO(state, action) {
    state.inboundRequestsItemsQuantityOfPO = action.payload;
  },
  setBrandTolerances(state, action) {
    state.brandTolerances = action.payload;
  },
  setBrandTolerancesLoading(state, action) {
    state.brandTolerancesLoading = action.payload;
  },
  setPickupAutocompleteData(state, action) {
    state.pickupAutocompleteData = action.payload;
  },
  setPickupAutocompleteDataLoading(state, action) {
    state.pickupAutocompleteDataLoading = action.payload;
  },
  setSupplierAddresses(state, action) {
    state.supplierAddresses = action.payload;
  },
  setSupplierAddressesLoading(state, action) {
    state.supplierAddressesLoading = action.payload;
  },
  setInboundRequestEmailHistory(state, action) {
    state.inboundRequestEmailHistory = action.payload;
  },
};

export const slice = createSlice({
  name: "inboundProcess",
  initialState: inboundProcessState,
  reducers,
});

export const { reducer } = slice;
